<template>
  <div class="box" v-if="!loading">
    <div class="center" :class="{ 'content-box': !hideTop }">
      <div v-if="!hideTop" class="banner-box">
        <img :src="kvUrl" alt="" class="banner" />
      </div>
      <div class="form">
        <div class="form-item-box">
          <el-form ref="form" :model="formData" label-position="top">
            <el-form-item
              v-for="item in dataList"
              :key="item.fieldName"
              :label="
                (item.displayType === '3' &&
                  item.fieldName != 'ExpandStorageTime') ||
                item.displayType === '5' || (item.displayName.length>15)
                  ? item.displayName
                  : ''
              "
              :prop="item.fieldName"
              v-if="!item.isHide"
              :class="
                [
                  'ExpandStorageTime',
                  'StorageBudget',
                  'DetailRequirements'
                ].includes(item.fieldName)
                  ? 'labelrequired'
                  : item.required == '1'
                  ? 'labelrequired'
                  : ''
              "
            >
<!--              <span style="position: relative;left: -100px">{{item.fieldName}}</span>-->

              <el-input
                v-if="
                  item.displayType == '1' &&
                  item.fieldName === 'DetailRequirements'
                "
                type="textarea"
                v-model="formData[item.fieldName]"
              >
              </el-input>
              <el-input
                v-if="
                  item.displayType == '1' &&
                  item.fieldName !== 'DetailRequirements' &&
                    item.fieldName !== 'enterprise'
                "
                type="text"
                :class="item.required == '1' && (item.displayName.length<15) ? 'required' : ''"
                :placeholder="(item.displayName.length>15)?'请输入':item.displayName"
                v-model="formData[item.fieldName]"
              >
              </el-input>
              <el-autocomplete
                  v-if="
                  item.displayType == '1' &&
                  item.fieldName == 'enterprise'
                "
                  :class="item.required == '1' ? 'required' : ''"
                  :trigger-on-focus="false"
                  v-model="formData[item.fieldName]"
                  :fetch-suggestions="querySearchAsync"
                  @blur="blurCompany"
                  :placeholder="item.displayName"
                  @select="handleSelect"
              ></el-autocomplete>
              <div class="province" v-if="item.fieldName === 'province'">
                <el-select
                  :placeholder="item.displayName"
                  v-model="formData[item.fieldName]"
                  :popper-class="formData[item.fieldName] ? 'myselected' : ''"
                  :class="item.required == '1' ? 'required' : ''"
                >
                  <el-option
                    v-for="items in item.dictInfo"
                    :key="items.dicID"
                    :label="items.name"
                    :value="items.name"
                    @click.native="
                      city = items.child[Object.keys(items.child)];
                      formData.city = '';
                    "
                  ></el-option>
                </el-select>
                <el-select
                  placeholder="城市"
                  :popper-class="formData.city ? 'myselected' : ''"
                  v-model="formData.city"
                  :class="{
                    required: item.required == '1',
                    diabled: formData[item.fieldName].length == 0
                  }"
                  :disabled="formData[item.fieldName].length == 0"
                >
                  <el-option
                    v-for="items in city"
                    :key="items.dicID"
                    :label="items.name"
                    :value="items.name"
                  ></el-option>
                </el-select>
              </div>

              <el-select
                v-else-if="
                  item.fieldType === 'LIST' &&
                  item.displayType === '4' &&
                  !['ExpandStorageTime', 'StorageBudget'].includes(
                    item.fieldName
                  )
                "
                :class="item.required == '1' ? 'required' : ''"
                :popper-class="formData[item.fieldName] ? 'myselected' : ''"
                :placeholder="item.displayName"
                v-model="formData[item.fieldName]"
              >
                <el-option
                  v-for="items in item.dictInfo"
                  :key="items.dicID"
                  :label="items.name"
                  :value="items.name"
                ></el-option>
              </el-select>
              <div
                class="extraConfig"
                v-if="item.fieldType === 'DESC'"
                v-html="item.extraConfig.htmlContent"
              ></div>

              <el-radio-group
                v-if="
                  item.fieldType === 'LIST' &&
                  item.displayType === '3' &&
                  !['ExpandStorageTime', 'StorageBudget'].includes(
                    item.fieldName
                  )
                "
                v-model="formData[item.fieldName]"
                @change="changeRadio(item)"
              >
                <el-radio
                  v-for="items in item.listOptions"
                  :key="items.id"
                  :label="items.optionValue"
                ></el-radio>
              </el-radio-group>
              <!-- 新增：radio选项的"其他"输入框 -->
              <div
                v-if="
                  item.fieldType === 'LIST' &&
                  item.displayType === '3' &&
                  !['ExpandStorageTime', 'StorageBudget'].includes(
                    item.fieldName
                  ) &&
                  shouldShowOtherInput(item)
                "
                style="margin-top: 10px;"
              >
                <el-input
                  v-model="otherInputValues[item.fieldName]"
                  type="text"
                  :placeholder="getOtherInputPlaceholder(item)"
                  :class="isOtherInputRequired(item) ? 'required' : ''"
                  style="width: 100%;"
                ></el-input>
              </div>

              <el-select
                v-else-if="
                  ['ExpandStorageTime', 'StorageBudget'].includes(
                    item.fieldName
                  )
                "
                :class="item.required == '1' ? 'required' : ''"
                :popper-class="formData[item.fieldName] ? 'myselected' : ''"
                :placeholder="item.displayName"
                v-model="formData[item.fieldName]"
              >
                <el-option
                  v-for="items in item.listOptions"
                  :key="items.id"
                  :label="items.optionValue"
                  :value="items.optionValue"
                ></el-option>
              </el-select>
              <el-checkbox-group
                v-if="item.fieldType === 'LIST' && item.displayType === '5'"
                v-model="formData[item.fieldName]"
              >
                <el-checkbox
                  v-for="d in item.listOptions"
                  :key="d.id"
                  :checked="d.checked"
                  :label="d.optionValue"
                  @change="changeSelect(item)"
                >
                  {{ d.optionValue }}
                </el-checkbox>
              </el-checkbox-group>
              <!-- 新增：checkbox选项的"其他"输入框 -->
              <div
                v-if="
                  item.fieldType === 'LIST' &&
                  item.displayType === '5' &&
                  shouldShowCheckboxOtherInput(item)
                "
                style="margin-top: 10px;"
              >
                <el-input
                  v-model="otherInputValues[item.fieldName]"
                  type="text"
                  :placeholder="getCheckboxOtherInputPlaceholder(item)"
                  :class="isCheckboxOtherInputRequired(item) ? 'required' : ''"
                  style="width: 100%;"
                ></el-input>
              </div>
              <!-- 新增：线下交流会的省市选择器 -->
              <div class="province" style="margin-top: 20px;" v-if="item.displayName === '希望技术交流会举办的时间和地点' && !item.isHide">
                <el-select
                  placeholder="省份"
                  v-model="offlineProvince"
                  :popper-class="offlineProvince ? 'myselected' : ''"
                  class="required"
                  @change="handleOfflineProvinceChange"
                >
                  <el-option
                    v-for="items in provinceOptions"
                    :key="items.dicID"
                    :label="items.name"
                    :value="items.name"
                  ></el-option>
                </el-select>
                <el-select
                  placeholder="城市"
                  :popper-class="offlineCity ? 'myselected' : ''"
                  v-model="offlineCity"
                  :class="{
                    required: true,
                    diabled: offlineProvince.length == 0
                  }"
                  :disabled="offlineProvince.length == 0"
                >
                  <el-option
                    v-for="items in offlineCityList"
                    :key="items.dicID"
                    :label="items.name"
                    :value="items.name"
                  ></el-option>
                </el-select>
              </div>
              <div class="yinsi" v-if="item.fieldName === 'privacyPolicy'">
                <span class="ysrequire" style="">*</span>
                <el-checkbox v-model="formData[item.fieldName]">
                  <span class="ystxt" v-html="item.privacyPolicyTitle"></span>
                </el-checkbox>
              </div>
              <div
                class="phone-code"
                v-if="item.fieldName == 'mobile' && isSendSms"
              >
                <el-form-item>
                  <div style="display: flex">
                    <el-input
                      v-model="phonecode"
                      type="text"
                      :class="item.required == '1' ? 'required' : ''"
                      placeholder="验证码"
                    >
                    </el-input>
                    <el-button
                      type="primary"
                      @click="getCode"
                      :disabled="phonedisabled"
                      class="code"
                      >{{ codeText }}</el-button
                    >
                  </div>
                </el-form-item>
              </div>
            </el-form-item>
          </el-form>
          <div class="footer">
            <el-button
              class="btn"
              type="primary"
              @click="onSubmit"
              v-loading="isSubDis"
              >提交</el-button
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import url from '@/plugins/url';

export default {
  name: 'Index',

  data() {
    return {
      customFormId: url.GetQueryString('customFormId'),
      globalUserId: this.$store.state.userInfo.globalUserId,
      id: url.GetQueryString('customFormId'),
      linkId: url.GetQueryString('linkId'),
      tenantId: this.$store.state.userInfo.tenantId,
      instanceId: this.$store.state.userInfo.instanceId,
      moduleId: this.$store.state.userInfo.moduleId,
      hideTop: false,
      kvUrl: '',
      wapkvUrl: '',
      configId: '',
      weChatId: '',
      dataList: '',
      city: [],
      formData: {
        city: []
      },
      customFormInfo: {},
      loading: true,
      isYinsi: false,
      isSendSms: false,
      phonedisabled: false,
      codeText: '获取验证码',
      phonecode: '',
      isSubDis: false,
      comlist:[],
      industrys:[],
      currentComName:"",
      // 新增：线下交流会的省市字段
      offlineProvince: '',
      offlineCity: '',
      offlineCityList: [],
      provinceOptions: [],
      // 新增：存储radio选项的"其他"输入框内容
      otherInputValues: {}
    };
  },
  watch:{
    "formData.province"(newVal,oldVal){
      console.log(newVal)
      if(newVal){
        this.dataList.forEach((list) => {
           if(list.displayName=='您希望参加线下技术交流会的具体城市是：'){
             this.formData[list.fieldName]=newVal
           }
        });
      }
    },
    "formData.city"(newVal,oldVal){
      if(newVal){
        this.dataList.forEach((list) => {
          if(list.displayName=='您希望参加线下技术交流会的具体城市是：'){
            this.formData[list.fieldName]=this.formData.province+newVal
          }
        });
      }
    },
    // 新增：监听线下交流会省市变化，自动赋值给"自定义省市"字段
    offlineProvince(newVal){
      this.updateCustomProvinceCity();
      this.checkStorageTechFieldVisibility();
    },
    offlineCity(newVal){
      this.updateCustomProvinceCity();
      this.checkStorageTechFieldVisibility();
    },
    // 新增：深度监听formData变化，用于检查希望技术交流会举办的时间和地点字段等
    formData: {
      handler(newVal) {
        this.$nextTick(() => {
          this.checkStorageTechFieldVisibility();
          this.checkJointSolutionFieldVisibility();
          this.checkExchangeMethodFieldVisibility();
          this.checkChannelFieldVisibility();
        });
      },
      deep: true
    }
  },
  created() {
    console.log(url.GetQueryString('hideTop'));
    if (url.GetQueryString('hideTop')) {
      this.hideTop = true;
    }
    this.initFontSize();
    this.getForm();
  },
  mounted() {
    this.customFormBrowse();
    this.customFormView();
  },

  methods: {
    // 新增：检查"通过何种渠道了解社区"相关字段的显示
    checkChannelFieldVisibility() {
      let selectedChannel = '';
      // 找到"通过何种渠道了解社区"的选择值
      this.dataList.forEach((item) => {
        // console.log(item.displayName)
        if (item.displayName === '1、通过何种渠道了解社区') {
          selectedChannel = this.formData[item.fieldName];
        }
      });

      // 根据选择显示对应的字段
      const channelFieldMap = {
        '联想凌拓<时光博物馆>解决方案邮件': '请写明邮件主题关键词',
        '联想凌拓<森林的心跳>官方技术交流活动': '活动举办日期及城市',
        '联想凌拓存储技术社区会员推荐': '请提供该社区会员微信ID号',
        '同行推荐': '请提供同行的企业名称'
      };

      // 隐藏所有相关字
      Object.values(channelFieldMap).forEach(fieldName => {
        this.dataList.forEach((item) => {
          debugger
          if (item.displayName === fieldName) {
            item.isHide = true;
            item.required = 0;
          }
        });
      });

      // 显示选中渠道对应的字段
      if (selectedChannel && channelFieldMap[selectedChannel]) {
        const fieldToShow = channelFieldMap[selectedChannel];
        this.dataList.forEach((item) => {
          if (item.displayName === fieldToShow) {
            item.isHide = false;
            item.required = 1;
          }
        });
      }
    },
    // 新增：判断是否显示"其他"输入框
    shouldShowOtherInput(item) {
      if (!item.listOptions || !this.formData[item.fieldName]) {
        return false;
      }
      // 查找当前选中的选项
      const selectedOption = item.listOptions.find(
        opt => opt.optionValue === this.formData[item.fieldName]
      );
      // 如果找到选项且 otherisFillIn 为 "1"，则显示输入框
      return selectedOption && selectedOption.otherisFillIn === "1";
    },
    // 新增：判断"其他"输入框是否必填
    isOtherInputRequired(item) {
      if (!item.listOptions || !this.formData[item.fieldName]) {
        return false;
      }
      const selectedOption = item.listOptions.find(
        opt => opt.optionValue === this.formData[item.fieldName]
      );
      return selectedOption && selectedOption.otherIsRequire === "1";
    },
    // 新增：获取"其他"输入框的占位符
    getOtherInputPlaceholder(item) {
      const isRequired = this.isOtherInputRequired(item);
      return isRequired ? '请输入其他内容（必填）' : '请输入其他内容';
    },
    // 新增：判断checkbox是否显示"其他"输入框
    shouldShowCheckboxOtherInput(item) {
      if (!item.listOptions || !this.formData[item.fieldName] || !Array.isArray(this.formData[item.fieldName])) {
        return false;
      }
      // 检查选中的选项中是否有需要填写其他内容的
      return item.listOptions.some(opt => {
        return this.formData[item.fieldName].includes(opt.optionValue) && opt.otherisFillIn === "1";
      });
    },
    // 新增：判断checkbox的"其他"输入框是否必填
    isCheckboxOtherInputRequired(item) {
      if (!item.listOptions || !this.formData[item.fieldName] || !Array.isArray(this.formData[item.fieldName])) {
        return false;
      }
      // 检查选中的选项中是否有必填的其他内容
      return item.listOptions.some(opt => {
        return this.formData[item.fieldName].includes(opt.optionValue) &&
               opt.otherisFillIn === "1" &&
               opt.otherIsRequire === "1";
      });
    },
    // 新增：获取checkbox"其他"输入框的占位符
    getCheckboxOtherInputPlaceholder(item) {
      const isRequired = this.isCheckboxOtherInputRequired(item);
      return isRequired ? '请输入其他内容（必填）' : '请输入其他内容';
    },
    // 新增：更新自定义省市字段的值
    updateCustomProvinceCity() {
      this.dataList.forEach((item) => {
        if (item.displayName === '自定义省市') {
          // 拼接省市值
          let value = '';
          if (this.offlineProvince && this.offlineCity) {
            value = this.offlineProvince + this.offlineCity;
          } else if (this.offlineProvince) {
            value = this.offlineProvince;
          }
          this.formData[item.fieldName] = value;
        }
      });
    },
    // 新增：检查"请选择您希望重点了解的存储技术或方案："字段的显示
    checkStorageTechFieldVisibility() {
      let isOfflineSelected = false;
      let isOfflineNo = false;
      let monthFieldVisible = false;
      let monthFieldName = '';
      let monthHasValue = false;
      let hasExchangeMethodSelection = false;

      this.dataList.forEach((item) => {
        if (item.displayName === '是否希望参加线下技术交流会') {
          isOfflineSelected = this.formData[item.fieldName] === '是';
          isOfflineNo = this.formData[item.fieldName] === '否';
        }
        if (item.displayName === '希望技术交流会举办的时间和地点') {
          monthFieldVisible = !item.isHide;
          monthFieldName = item.fieldName;
          monthHasValue = this.formData[item.fieldName] && this.formData[item.fieldName].length > 0;
        }
        if (item.displayName === '希望通过哪种方式交流') {
          const value = this.formData[item.fieldName];
          if (Array.isArray(value)) {
            hasExchangeMethodSelection = value.length > 0;
          }
        }
      });

      // 场景1：选择了"是"，希望技术交流会举办的时间和地点显示了，并且省市都填写了
      const shouldShowForOffline = isOfflineSelected &&
                                   monthFieldVisible &&
                                   this.offlineProvince &&
                                   this.offlineCity &&
                                   monthHasValue;

      // 场景2：选择了"否"，并且"希望通过哪种方式交流"有选择
      const shouldShowForOnline = isOfflineNo && hasExchangeMethodSelection;

      // 只要满足任一场景就显示
      const shouldShow = shouldShowForOffline || shouldShowForOnline;

      this.dataList.forEach((item) => {
        if (item.displayName === '请选择您希望重点了解的存储技术或方案：') {
          item.isHide = !shouldShow;
          item.required = shouldShow ? 1 : 0;
        }
      });
    },
    // 新增：检查"您希望形成的联合解决方案场景"字段的显示
    checkJointSolutionFieldVisibility() {
      // 检查"加入技术社区，主要交流目的是"是否选择了"与联想凌拓和生态企业，探讨联合解决方案"
      let hasJointSolutionOption = false;

      this.dataList.forEach((item) => {
        if (item.displayName === '2、加入技术社区，主要交流目的是') {
          const value = this.formData[item.fieldName];
          if (Array.isArray(value)) {
            hasJointSolutionOption = value.includes('与联想凌拓和生态企业，探讨联合解决方案');
          }
        }
      });

      // 根据选择显示或隐藏"您希望形成的联合解决方案场景"
      this.dataList.forEach((item) => {
        if (item.displayName === '您希望形成的联合解决方案场景') {
          item.isHide = !hasJointSolutionOption;
          item.required = hasJointSolutionOption ? 1 : 0;
        }
      });
    },
    // 新增：检查"请选择您希望重点了解的存储技术或方案"字段的显示（针对"希望通过哪种方式交流"）
    checkExchangeMethodFieldVisibility() {
      // 检查"希望通过哪种方式交流"是否选择了任何选项
      let hasAnySelection = false;

      this.dataList.forEach((item) => {
        if (item.displayName === '希望通过哪种方式交流') {
          const value = this.formData[item.fieldName];
          if (Array.isArray(value)) {
            hasAnySelection = value.length > 0;
          }
        }
      });

      // 注意：这个字段不再由 checkExchangeMethodFieldVisibility 控制
      // 只由 checkStorageTechFieldVisibility 控制（当选择线下交流会且填写完省市后显示）
    },
    // 新增：处理线下交流会省份变化
    handleOfflineProvinceChange(province) {
      this.offlineCity = '';
      this.offlineCityList = [];
      // 从provinceOptions中找到对应省份的城市数据
      const selectedProvince = this.provinceOptions.find(item => item.name === province);
      if (selectedProvince && selectedProvince.child) {
        this.offlineCityList = selectedProvince.child[Object.keys(selectedProvince.child)];
      }
    },
    querySearchAsync(queryString, cb){
      var restaurants = this.comlist;
      if(!queryString){
        return
      }
      this.$api.getCompanyQuery({keyword:queryString}).then(res=>{
        let list=[];
        res.data.forEach(item=>{
          list.push({value:item.companyName})
        })
        cb(list);
      })
    },
    blurCompany(){
      if(this.formData.enterprise && this.formData.enterprise !==this.currentComName){
        this.handleSelect({value:this.formData.enterprise})
      }
    },
    handleSelect(data,callback){
     if(!data.value){
       return;
     }
     this.currentComName=data.value
      this.$api.getCompanyData({company:data.value}).then(res=>{
        console.log(res)
        if(res.data.length===0){
          res.data={}
        }
        let isIndustry=true
       if(res.data.industry){
         this.industrys.forEach(item=>{
           if(item.name===res.data.industry){
             isIndustry=false
           }
         })
       }
        this.dataList.forEach((item,index)=>{
          if(item.fieldName==='province'){
            if( res.data.province && res.data.city){
              this.formData[item.fieldName]=res.data.province;
              item.dictInfo.forEach(itm=>{
                if(itm.name===res.data.province){
                  this.city=   itm.child[Object.keys(itm.child)]
                }
              })
              if(res.data.city){
                this.formData['city']=res.data.city;
              }
            }else{

            }
          }

          if(item.displayName==='经营状态'){
            this.formData[item.fieldName]=res.data.regStatus;
          }
          if(item.displayName==='营业收入'){
            this.formData[item.fieldName]=res.data.totalSales;
          }
          if(item.displayName==='人员规模'){
            this.formData[item.fieldName]=res.data.staffNumRange;
          }
          if(!data.isSub){
            if(item.fieldName==='industry'){
              if(!isIndustry){
                // this.formData[item.fieldName]=res.data.industry;
                // item.isHide=true;
                this.$set(this.formData,item.fieldName,res.data.industry)
                this.$set(this.dataList[index],'isHide',true)
              }else{
                // this.formData[item.fieldName]='';
                // item.isHide=false;
                this.$set(this.formData,item.fieldName,'')
                this.$set(this.dataList[index],'isHide',false)
              }
            }
          }

        })
        callback && callback()
      })
    },
    createStateFilter(queryString) {
      return (state) => {
        return (state.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
      };
    },
    getCode() {
      if (!this.formData['mobile']) {
        this.$message.error('手机号不能为空');
        return;
      }
      //验证手机号
      if (!/^1[3456789]\d{9}$/.test(this.formData['mobile'])) {
        this.$message.error('手机号格式不正确');
        return;
      }
      this.phonedisabled = true;
      this.$api
        .sendCode({
          mobile: this.formData['mobile'],
          customFormId: this.customFormId,
          globalUserId: this.globalUserId
        })
        .then((res) => {
          this.codeText = '60s';
          let timer = setInterval(() => {
            let num = parseInt(this.codeText) - 1;
            if (num === 0) {
              clearInterval(timer);
              this.phonedisabled = false;
              this.codeText = '获取验证码';
            } else {
              this.codeText = num + 's';
            }
          }, 1000);
        });
    },
    initFontSize() {
      if (document.documentElement.getBoundingClientRect().width <= 750) {
        document.documentElement.style.fontSize =
          (document.documentElement.getBoundingClientRect().width / 750) * 100 +
          'px';
      }
    },
    async getForm() {
      const data = {
        customFormId: this.customFormId,
        globalUserId: this.globalUserId,
        id: this.id,
        tenantId: this.tenantId
      };
      let arr = await this.$api.acquireFormAPI(data);
      let formData = {
        city: ''
      };
      var hideField=['经营状态','营业收入','人员规模','您希望参加线下技术交流会的具体城市是：','自定义省市','请选择您希望重点了解的存储技术或方案：','您希望形成的联合解决方案场景','请选择您希望重点了解的存储技术或方案','请写明邮件主题关键词','活动举办日期及城市','请提供该社区会员微信ID号','请提供同行的企业名称'];
      arr.content.items.forEach((item) => {
        if (
          item.fieldName == 'DetailRequirements' ||
          item.fieldName == 'ExpandStorageTime' ||
          item.fieldName == 'StorageBudget'
        ) {
          item.isHide = true;
          item.required = 0;
        }
        if (item.displayType != '9') {
          if (item.displayType == '5') {
            if (item.fieldName == 'Relevantinformation') {
              formData[item.fieldName] = [
                '我希望通过电子邮件接收联想凌拓的相关资讯',
                '我希望通过电话接收联想凌拓的相关资讯'
              ];
            } else {
              formData[item.fieldName] = [];
            }
          } else {
            formData[item.fieldName] = '';
          }
        }
        if (item.fieldName == 'privacyPolicy') {
          this.isYinsi = true;
          formData[item.fieldName] = !!item.isSelected;
        }
        if (item.fieldName == 'mobile') {
          this.isSendSms = item.isSendSms;
        }
        if(hideField.indexOf(item.displayName)>-1){
          item.isHide=true
        }

        if(item.fieldName==='industry'){
          this.industrys=item.dictInfo
        }

        // 获取省份数据用于线下交流会的省市选择器
        if(item.fieldName==='province' && item.dictInfo){
          this.provinceOptions=item.dictInfo;
        }

        // 新增定制化逻辑：默认隐藏希望技术交流会举办的时间和地点、希望通过哪种方式交流字段
        if(item.displayName==='希望技术交流会举办的时间和地点' || item.displayName==='希望通过哪种方式交流'){
          item.isHide=true;
          item.required = 0;
        }
      });
      document.title = arr.content.shareTitle;
      this.formData = JSON.parse(JSON.stringify(formData));
      console.log( arr.content.items)

      this.dataList = arr.content.items;
      this.customFormInfo = arr.content;
      this.checkRegistration();
      this.configId = this.customFormInfo.template.pc.configId;
      this.getFormConfig();
      console.log('customFormInfo', this.customFormInfo);
    },

    changeRadio(item) {
      console.log(item);
      console.log(this.formData[item.fieldName])
      if (item.fieldName == 'NeedSalesContactImmediately') {
        this.dataList.forEach((list) => {
          if (list.fieldName == 'DetailRequirements') {
            if (this.formData.NeedSalesContactImmediately == '是') {
              list.isHide = false;
              list.required = 1;
            } else {
              list.isHide = true;
              list.required = 0;
            }
          }
        });
      }
      if(item.displayName=='您是否希望参加，与本期技术交流会相同主题的，线下面对面的技术交流会？'){
          this.dataList.forEach((list) => {
            if (list.displayName == '您希望参加线下技术交流会的具体城市是：') {
              if (this.formData[item.fieldName] == '是') {
                list.isHide = false;
                list.required = 1;
              } else {
                list.isHide = true;
                list.required = 0;
              }
            }
          });
      }
      // 新增定制化逻辑：是否希望参加线下技术交流会
      if(item.displayName=='是否希望参加线下技术交流会'){
        this.dataList.forEach((list) => {
          // 选择"是"时，显示"希望技术交流会举办的时间和地点"字段（省市选择器会自动跟随希望技术交流会举办的时间和地点字段显示）
          if (list.displayName == '希望技术交流会举办的时间和地点') {
            if (this.formData[item.fieldName] == '是') {
              list.isHide = false;
              list.required = 1;
              // 清空"希望通过哪种方式交流"的值
              this.dataList.forEach((exchangeItem) => {
                if (exchangeItem.displayName == '希望通过哪种方式交流') {
                  this.formData[exchangeItem.fieldName] = [];
                }
              });
            } else {
              list.isHide = true;
              list.required = 0;
              // 隐藏时清空数据
              this.offlineProvince = '';
              this.offlineCity = '';
              this.offlineCityList = [];
              // 清空"希望技术交流会举办的时间和地点"的值
              this.formData[list.fieldName] = '';
            }
          }
          // 选择"否"时，显示"希望通过哪种方式交流"
          if (list.displayName == '希望通过哪种方式交流') {
            if (this.formData[item.fieldName] == '否') {
              list.isHide = false;
              list.required = 1;
              // 清空"希望技术交流会举办的时间和地点"和省市数据
              this.dataList.forEach((timeItem) => {
                if (timeItem.displayName == '希望技术交流会举办的时间和地点') {
                  this.formData[timeItem.fieldName] = '';
                }
              });
              this.offlineProvince = '';
              this.offlineCity = '';
              this.offlineCityList = [];
            } else {
              list.isHide = true;
              list.required = 0;
            }
          }
        });
        // 检查"请选择您希望重点了解的存储技术或方案："的显示
        this.$nextTick(() => {
          this.checkStorageTechFieldVisibility();
        });
      }
    },
    changeSelect(item) {
      console.log(item);
      console.log(this.formData[item.fieldName]);
      if (item.fieldName == 'StorageNeed') {
        this.dataList.forEach((list) => {
          if (
            list.fieldName == 'ExpandStorageTime' ||
            list.fieldName == 'StorageBudget'
          ) {
            list.isHide =
              !this.formData.StorageNeed.length ||
              (this.formData.StorageNeed.length == 1 &&
                this.formData.StorageNeed[0] === '暂无')
                ? true
                : false;
            list.required = list.isHide ? 0 : 1;
          }
        });
      }
    },
    // 浏览
    customFormView() {
      this.$api.customFormView({
        customFormId: this.customFormId,
        globalUserId: this.globalUserId,
        linkId: this.linkId,
        memberId: '',
        openId: '',
        referenceUrl: '',
        sess: '',
        tenantId: this.tenantId,
        url: '',
        weChatId: ''
      });
    },
    // 浏览
    customFormBrowse() {
      this.$api.customFormBrowse({
        customFormId: this.customFormId,
        globalUserId: this.globalUserId,
        openId: '',
        sess: '',
        tenantId: this.tenantId
      });
    },
    // 获取是否报过名
    checkRegistration() {
      this.$api
        .checkRegistration({
          customFormId: this.customFormId,
          globalUserId: this.globalUserId,
          instanceId: this.instanceId,
          openId: '',
          tenantId: this.tenantId
        })
        .then((res) => {
          if (this.moduleId != '2' && this.moduleId != '3') {
            if (res.content.signupStatus == 'notAllow') {
              this.submitAfter();
            }
          }
        });
    },
    // 获取模板配置信息
    getFormConfig() {
      this.$api
        .getFormConfig({
          configId: this.configId,
          globalUserId: this.globalUserId,
          tenantId: this.tenantId
        })
        .then((res) => {
          this.kvUrl =
            res.content.configInfo.html[0].extra[1].extras[0].extras[1].src.value;
          this.loading = false;
          this.$nextTick(() => {
            let height = document.body.scrollHeight;
            window.parent.postMessage(
              {
                action: 'documentHeight',
                height: height
              },
              '*'
            );
          });
        });
    },
    isValid() {
      let valid = false;
      let hasCity = false;
      for (let i = 0; i < this.dataList.length; i++) {
        // 跳过隐藏字段的验证
        if (this.dataList[i].isHide) {
          continue;
        }

        if (this.dataList[i].required == '1') {
          if (this.dataList[i].fieldName == 'province') {
            hasCity = true;
          }
          if (
            this.dataList[i].fieldName == 'mobile' ||
            this.dataList[i].fieldName == 'email'
          ) {
            if (this.formData[this.dataList[i].fieldName]) {
              if (
                !new RegExp(this.dataList[i].regularExpression).test(
                  this.formData[this.dataList[i].fieldName]
                )
              ) {
                alert(`请输入正确的${this.dataList[i].displayName}`);
                valid = true;
                break;
              }
            } else {
              alert(`请输入您的${this.dataList[i].displayName}`);
              valid = true;
              break;
            }
          } else {
            console.log(this.formData)
            console.log(this.dataList[i])
            console.log(this.formData[this.dataList[i].fieldName])
            console.log('-------')
            if (this.formData[this.dataList[i].fieldName].length == 0) {
              alert(`请输入您的${this.dataList[i].displayName}`);
              valid = true;
              break;
            }
          }
        }
      }
      if (!valid) {
        if (hasCity && this.formData.city.length == 0) {
          alert(`请选择您的城市`);
          valid = true;
        }
      }
      if (!valid && !this.phonecode && this.isSendSms) {
        this.$message({
          message: '请输入验证码！',
          type: 'warning'
        });
        valid = true;
      }
      if (!valid && !this.formData['privacyPolicy'] && this.isYinsi) {
        this.$message({
          message: '请勾选隐私政策',
          type: 'warning'
        });
        valid = true;
      }

      // 新增：验证线下交流会的省市字段
      if (!valid) {
        const monthField = this.dataList.find(item => item.displayName === '希望技术交流会举办的时间和地点');
        if (monthField && !monthField.isHide && monthField.required == '1') {
          if (!this.offlineProvince) {
            alert('请选择省份');
            valid = true;
          } else if (!this.offlineCity) {
            alert('请选择城市');
            valid = true;
          }
        }
      }

      // 新增：验证radio选项的"其他"输入框
      if (!valid) {
        for (let i = 0; i < this.dataList.length; i++) {
          const item = this.dataList[i];
          if (item.isHide) continue;

          if (item.fieldType === 'LIST' && item.displayType === '3' && item.listOptions) {
            const selectedOption = item.listOptions.find(
              opt => opt.optionValue === this.formData[item.fieldName]
            );

            // 如果选中的选项需要填写其他内容
            if (selectedOption && selectedOption.otherisFillIn === "1") {
              const otherValue = this.otherInputValues[item.fieldName];

              // 如果该选项的其他内容是必填的
              if (selectedOption.otherIsRequire === "1") {
                if (!otherValue || otherValue.trim().length === 0) {
                  alert(`请填写"${item.displayName}"的其他内容`);
                  valid = true;
                  break;
                }
              }
            }
          }

          // 新增：验证checkbox选项的"其他"输入框
          if (item.fieldType === 'LIST' && item.displayType === '5' && item.listOptions) {
            // 检查是否有选中的选项需要填写其他内容
            const hasOtherFillIn = item.listOptions.some(opt => {
              return this.formData[item.fieldName] &&
                     Array.isArray(this.formData[item.fieldName]) &&
                     this.formData[item.fieldName].includes(opt.optionValue) &&
                     opt.otherisFillIn === "1";
            });

            if (hasOtherFillIn) {
              const otherValue = this.otherInputValues[item.fieldName];

              // 检查是否必填
              const isRequired = item.listOptions.some(opt => {
                return this.formData[item.fieldName].includes(opt.optionValue) &&
                       opt.otherisFillIn === "1" &&
                       opt.otherIsRequire === "1";
              });

              if (isRequired && (!otherValue || otherValue.trim().length === 0)) {
                alert(`请填写"${item.displayName}"的其他内容`);
                valid = true;
                break;
              }
            }
          }
        }
      }

      return valid;
    },
    onSubmit(isSub) {
      let isVa = this.isValid();
      let submitData = [];
      if (!isVa) {
        this.dataList.forEach((item) => {
          if (item.fieldType === 'LIST') {
            if (item.displayType === '3' || item.displayType === '4') {
              if (item.fieldName == 'province') {
                submitData.push({
                  fieldName: item.fieldName,
                  value: [this.formData.province, this.formData.city]
                });
              } else {
                // 检查是否有"其他"输入框的内容需要一起提交
                let valueToSubmit = [this.formData[item.fieldName]];
                if (this.otherInputValues[item.fieldName]) {
                  // 将其他内容拼接到选项值后面
                  valueToSubmit = [this.formData[item.fieldName] + '：' + this.otherInputValues[item.fieldName]];
                }
                submitData.push({
                  fieldName: item.fieldName,
                  value: valueToSubmit
                });
              }
            } else {
              if (item.displayType === '5') {
                // 检查是否有"其他"输入框的内容需要一起提交
                let valueToSubmit = this.formData[item.fieldName];

                // 如果有其他内容输入
                if (this.otherInputValues[item.fieldName] && this.otherInputValues[item.fieldName].trim()) {
                  // 检查是否有选项需要填写其他内容
                  const hasOtherOption = item.listOptions && item.listOptions.some(opt => {
                    return valueToSubmit &&
                           Array.isArray(valueToSubmit) &&
                           valueToSubmit.includes(opt.optionValue) &&
                           opt.otherisFillIn === "1";
                  });

                  if (hasOtherOption) {
                    // 将其他内容添加到数组中
                    valueToSubmit = [...valueToSubmit, '其他：' + this.otherInputValues[item.fieldName]];
                  }
                }

                submitData.push({
                  fieldName: item.fieldName,
                  value: valueToSubmit
                });
              }
            }
          } else {
            if (item.displayType != '9') {
              submitData.push({
                fieldName: item.fieldName,
                value: this.formData[item.fieldName]
              });
            }
          }
        });
        if (this.isSubDis) {
          return;
        }
        this.isSubDis = true;
        // 请求完获取企业信息在提交
        if(isSub!=1){
          this.handleSelect({value:this.formData.enterprise,isSub:1},res=>{
            this.isSubDis = false;
            this.onSubmit(1)
          })
          return;
        }
        this.$api
          .customFormAction({
            customFormId: this.customFormId,
            globalUserId: this.globalUserId,
            instanceId: this.instanceId,
            items: submitData,
            linkId: this.linkId,
            openId: '',
            referenceUrl: '',
            sess: '',
            session: '',
            verificationCode: this.phonecode,
            url: window.location.href,
            signPointItems: [],
            tenantId: this.tenantId,
            ver: 'v2.0.1'
          })
          .then(
            (res) => {
              this.isSubDis = false;
              if (res.result == '0') {
                this.submitAfter();
              } else {
              }
            },
            (err) => {
              this.isSubDis = false;
              if (err.result == '200730') {
                let cnNameObj = {
                  mobile: '手机号',
                  email: '邮箱'
                };
                let string = '';
                err.content.repeatFields.forEach((item) => {
                  string = string + cnNameObj[item];
                });
                string += '字段内容已存在，请重新填写！';
                alert(string);
              } else {
                alert(err.desc);
              }
            }
          );
      }
      console.log('submitData=>', submitData);
      console.log('formData=>', this.formData);
    },
    submitAfter() {
      if (this.hideTop) {
        if (this.customFormInfo.completeActionType == '2') {
          window.parent.location.href = this.customFormInfo.completeAction;
        }
      } else {
        if (this.customFormInfo.completeActionType == '2') {
          window.location.href = this.customFormInfo.completeAction;
        }
      }
    }
  }
};
</script>
<style>
@media screen and (min-width: 750px) {
}
.el-checkbox__input{
  vertical-align: top;
  margin-top: 5px;
}
.el-form .el-checkbox .el-checkbox__label{
  white-space: pre-wrap;
}
.el-radio__label {
  white-space: pre-wrap;
}
.extraConfig p span {
    text-wrap: wrap !important;
}
</style>
<style scoped>
@media screen and (max-width: 750px) {
  .yinsi {
    padding-left: 20px;
  }

  .yinsi ::v-deep .el-checkbox__input {
    top: 2px;
    position: absolute;
    left: -7px;
  }

  .yinsi .ysrequire {
    color: red;
    margin-right: 10px;
    top: 11px;
    position: absolute;
    left: 0;
  }
}

.ystxt {
  word-break: break-word;
  display: block;
  line-height: 1.5;
  white-space: pre-wrap;
}

.ysrequire {
  color: red;
  margin-right: 10px;
  top: 2px;
  position: relative;
}

.phone-code {
  margin-top: 22px;
}

.code {
  margin-left: 20px;
  width: 120px;
  background: #7f2854;
  border-color: #7f2854;
}

.code:hover {
  background: #7f2854;
  border-color: #7f2854;
}

.code:active,
.code:focus {
  background: #7f2854;
  border-color: #7f2854;
}

.code.is-disabled {
  background: #7f28547a;
  border-color: #7f28547a;
}

.code.is-disabled:hover {
  background: #7f28547a;
  border-color: #7f28547a;
}

.yinsi ::v-deep a {
  color: #7f2854;
}




.el-form-item label.el-radio {
    margin: 10px 0px 10px 10px;
}
</style>
